var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrap},[_c('div',{ref:"container3d",class:_vm.$style.canvas})])
}
var staticRenderFns = []

export { render, staticRenderFns }